<template>
  <div>
    <div v-if="documents.length == 0" class="overflow-hidden bg-white rounded-lg shadow p-4">
      Não há Documentos
    </div>
    <div v-else>
      <div class="grid grid-cols-3 gap-4">
        <div class="col-span-1 overflow-hidden bg-white rounded-lg shadow p-4">
          Seção
        </div>
        <div class="col-span-2 overflow-hidden bg-white rounded-lg shadow">
          <div class="p-4">
            <ul class="divide-y divide-gray-200">
              <div v-for="(document, index) in documents" :key="index">
                <a class="text-default-600 text-lg" href="#">
                  {{document.title}}
                </a>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Semed from "./../../api/Semed";

export default {
  name: 'index',
  props: ["path"],
  data() {
    return {
      documents: null,
    };
  },
  created() {
    Semed.get(this.path).then((response) => {
      this.documents = response.data;
    });
  },
}
</script>

<style scoped>
.document-description{
    font-size: 0.75rem ;
}
</style>
